var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.856445 2.14467L5.21306 6.5004L0.856445 10.8561L2.72785 12.7275L8.9541 6.5004L2.72785 0.273269L0.856445 2.14467Z","fill":"white"}));
}

ChevronRightInline.defaultProps = {"width":"9","height":"13","viewBox":"0 0 9 13","fill":"none"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
